import React from "react";

import PropTypes from "prop-types";

import { Control, Label, Input, Field } from "rbx";

import {
  DateInput,
  CustomerSelect,
  BooleanInput,
  PaymentTermSelect
} from "../../../../components/inputs";
import { RouteTariffDisplay } from "../../../../components/Routes";

import HorizontalRule from "../../../../styles/HorizontalRule";

import { RouteProducts } from "../components";

const Billing = ({ route, onChange, editing }) => (
  <React.Fragment>
    <div className="row route-info">
      <Field>
        <Control>
          <CustomerSelect
            showHelp
            icon="money-bill"
            label="Bill To"
            name="BillToRecIdRef"
            readOnly={!editing}
            showCityAndState={false}
            value={route.BillToRecIdRef}
            variables={{
              where: { Active: true, BillToCust: true },
              orderByMulti: ["CustomerNo_ASC"]
            }}
            onChange={onChange}
          />
        </Control>
      </Field>
      <Field>
        <Control expanded>
          <Label>Contract</Label>
          <Input
            autocomplete="new"
            name="Contract"
            readOnly={!editing}
            type="text"
            value={route.Contract}
            onChange={onChange}
          />
        </Control>
      </Field>
      <Field>
        <Control>
          <PaymentTermSelect
            disabled={!editing}
            label="Payment Term"
            name="PaymentTermsRecIdRef"
            value={route?.PaymentTermsRecIdRef}
            where={{ Active: true }}
            onChange={onChange}
          />
        </Control>
      </Field>
      <Field>
        <Control>
          <Label>No Bills</Label>
          <BooleanInput
            name="NonBill"
            value={route.NonBill}
            onChange={onChange}
          />
        </Control>
      </Field>
      <Field>
        <Control expanded>
          <Label>Max. Load Time</Label>
          <Input
            name="MaxLoadTime"
            readOnly={!editing}
            type="number"
            value={route.MaxLoadTime}
            onChange={onChange}
          />
        </Control>
      </Field>
      <Field>
        <Control expanded>
          <Label>Max. Unload Time</Label>
          <Input
            name="MaxUnloadTime"
            readOnly={!editing}
            type="number"
            value={route.MaxUnloadTime}
            onChange={onChange}
          />
        </Control>
      </Field>
      <Field>
        <Control expanded>
          <Label>Start Date</Label>
          <DateInput
            name="StartDate"
            readOnly={!editing}
            value={route.StartDate}
            onChange={onChange}
          />
        </Control>
      </Field>
      <Field>
        <Control expanded>
          <Label>End Date</Label>
          <DateInput
            name="EndDate"
            readOnly={!editing}
            value={route.EndDate}
            onChange={onChange}
          />
        </Control>
      </Field>
    </div>
    <HorizontalRule />

    <RouteTariffDisplay readOnly={!editing} route={route} onChange={onChange} />

    <HorizontalRule />

    <RouteProducts route={route} />
  </React.Fragment>
);

Billing.propTypes = {
  route: PropTypes.object,
  editing: PropTypes.bool,
  onChange: PropTypes.func
};
export default Billing;
